import { render, staticRenderFns } from "./payment-deduction.vue?vue&type=template&id=7e2d07a6&scoped=true&"
import script from "./payment-deduction.vue?vue&type=script&lang=js&"
export * from "./payment-deduction.vue?vue&type=script&lang=js&"
import style0 from "./payment-deduction.vue?vue&type=style&index=0&id=7e2d07a6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7e2d07a6",
  null
  
)

/* custom blocks */
import block0 from "./payment-deduction.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(component)

export default component.exports